<template>
  <div></div>
</template>

<script>
import auth from '@/services/auth'
import logger from '@/services/logger'

export default {
  created () {
    logger.setFields({})
  },
  beforeMount () {
    auth.loginAs(this.$route.params.token, JSON.parse(atob(this.$route.query.user)), true)
  }
}
</script>
